// extracted by css-extract-rspack-plugin
var _1 = "iL4fdmgUcI887o1e";
var _2 = "C_WHg2oIObknzdWi";
var _3 = "JMhPTIXM278mzB3j";
var _4 = "Jnc3cYdaOjYdVQ_S";
var _5 = "TZRI5_QwEyksT_Yh";
var _6 = "neO4DRaqprUVktnZ";
var _7 = "PY3xAZcArAFStTYF";
var _8 = "XDx9JgNjroI5YjO_";
var _9 = "JxDfRHL7qJY8MQVt";
export { _1 as "placeholderSkeleton", _2 as "skeletonAnimate", _3 as "timelineSkeletonDetail1", _4 as "timelineSkeletonDetail2", _5 as "timelineSkeletonIcon", _6 as "timelineSkeletonTitle", _7 as "timelineSkeletonWrapper", _8 as "timelineSkeletonWrapperBody", _9 as "timelineSkeletonWrapperInner" }
